// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer___2BRHe","footerContent":"Footer__footerContent___1DiJz","policies":"Footer__policies___3PTh1","policiesLinks":"Footer__policiesLinks___2SUrI","navigation":"Footer__navigation___2ExZ7","logo":"Footer__logo___1vxvf"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/common/footer/Footer.scss
// module id = 1989
// module chunks = 0